type MetadataProps = {
  text?: string;
};

export function Metadata({ text: _text }: MetadataProps) {
  return null;
}
